var v = Object.defineProperty;
var b = (d, o, p) =>
  o in d
    ? v(d, o, { enumerable: !0, configurable: !0, writable: !0, value: p })
    : (d[o] = p);
var u = (d, o, p) => (b(d, typeof o != "symbol" ? o + "" : o, p), p);
(function () {
  "use strict";
  const h = class h {
    constructor(n, e) {
      u(this, "variantIds", new Set());
      u(this, "variants", {});
      u(this, "prices", []);
      return (
        (this.percentage = n),
        (this.enabled = e),
        h.instance && (h.instance = this),
        h.instance
      );
    }
    get highestPrice() {
      return this.prices[this.prices.length - 1];
    }
    get lowestPrice() {
      return this.prices[0];
    }
    setVariants(n) {
      ((this.prices.length = 0), this.variantIds.clear());
      for (const e of Object.keys(this.variants)) delete this.variants[e];
      this.prices.push(
        ...Object.keys(n)
          .map(Number)
          .sort((e, i) => e - i),
      );
      for (const e of Object.keys(n))
        ((this.variants[e] = n[e]), this.variantIds.add(n[e]));
    }
    async getNonPackageProtectionItems() {
      return (await window.weNexusCartApi.get()).items.filter(
        (e) => !this.variantIds.has(e.variant_id),
      );
    }
    async getPackageProtectionItems() {
      return (await window.weNexusCartApi.get()).items.filter((e) =>
        this.variantIds.has(e.variant_id),
      );
    }
    async calculate() {
      if (this.prices.length === 0)
        throw new Error("No variants have been set");
      const e =
        (await this.getNonPackageProtectionItems()).reduce(
          (r, a) => r + a.final_line_price,
          0,
        ) / 100;
      let i = this.lowestPrice.toFixed(2),
        t = (e / 100) * this.percentage;
      if (t <= this.highestPrice && t >= this.lowestPrice) {
        for (const r of this.prices)
          if (r > t) {
            i = r.toFixed(2);
            break;
          }
      } else
        t > this.highestPrice
          ? (i = this.highestPrice.toFixed(2))
          : t < this.lowestPrice && (i = this.lowestPrice.toFixed(2));
      return {
        actualPrice: Number(t.toFixed(2)),
        variantId: this.variants[i],
        coercedPrice: i,
        forPrice: e,
      };
    }
    async add() {
      if ((await this.getPackageProtectionItems()).length > 0) return;
      const { variantId: e } = await this.calculate();
      return (
        await window.weNexusCartApi.append([{ id: e, quantity: 1 }], !1)
      ).items.find((t) => t.variant_id === e);
    }
    async remove() {
      if (this.prices.length === 0)
        throw new Error("No variants have been set");
      const n = await this.getPackageProtectionItems();
      if (n.length !== 0)
        return (
          await window.weNexusCartApi.remove(
            n.map((e) => e.variant_id),
            !1,
          ),
          n[0]
        );
    }
    async change(n) {
      if (this.prices.length === 0)
        throw new Error("No variants have been set");
      const e = await this.getPackageProtectionItems();
      const t = e.find((a) => a.variant_id === n);
      if (t) return t;
      if (e.length > 0) {
        await window.weNexusCartApi.remove(
          e.map((a) => a.variant_id),
          !1,
        );
      }
      return (
        await window.weNexusCartApi.append([{ id: n, quantity: 1 }], !1)
      ).items.find((a) => a.variant_id === n);
    }
    async refresh() {
      const n = await this.getNonPackageProtectionItems();
      if (!this.enabled || n.length === 0) return this.remove();
      const e = await this.getPackageProtectionItems();
      if (e.length === 0) return this.add();
      const { variantId: i } = await this.calculate();
      if (
        (e.length > 1 &&
          (await window.weNexusCartApi.remove(
            e.filter((t) => t.variant_id !== i).map((t) => t.variant_id),
            !1,
          )),
        e.some((t) => t.variant_id === i))
      )
        return e.find((t) => t.variant_id === i);
      return this.change(i);
    }
  };
  u(h, "instance");
  let d = h;
  class o {
    constructor(n) {
      u(
        this,
        "thumbnail",
        "https://cdn.shopify.com/s/files/1/1652/8827/files/g4990.png?v=1708754054",
      );
      u(this, "infoPageLink", "/pages/package-protection");
      u(this, "container", null);
      this.api = n;
    }
    formatPrice(n, e) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        currency: e,
      }).format(n);
    }
    async getPrice() {
      const { coercedPrice: n } = await this.api.calculate(),
        e = await window.weNexusCartApi.get();
      return this.formatPrice(Number(n), e.currency);
    }
    async getCheckboxContainer(n) {
      const e = document.createElement("div"),
        i = await this.getPrice();
      e.insertAdjacentHTML(
        "afterbegin",
        `
      <div class="wenexus-package-protection__content">
          <div class="wenexus-package-protection__image">
              <img src="${this.thumbnail}" alt="Package Protection" />
          </div>
          <div class="wenexus-package-protection__desc">
              <h5>Package Protection <a href="${this.infoPageLink}" target="_blank">ⓘ</a></h5>
              <p>Covers Damage, Loss & Theft for <strong class="protection-price">${i}</strong></p>
          </div>
      </div>
      <div class="wenexus-package-protection__toggle">
          <input type="checkbox">
      </div>
`,
      );
      const t = e.querySelector(".wenexus-package-protection__toggle input");
      return (
        (e.className = "wenexus-package-protection"),
        (t.checked = n),
        (this.container = e),
        { container: e, checkbox: t }
      );
    }
    async getStyleMarkup({
      accentColor: n,
      imageWidth: e = 56,
      containerGap: i = [0, 10],
      contentGap: t = [0, 10],
      descriptionFontWeight: r = "bold",
      descriptionFontSize: a = 0.8,
      descriptionMargin: c = [0, 0, 0, 0],
      titleFontSize: f = 1.4,
      hideDescriptionPage: w = !0,
      containerMargin: s = [0, 0, 8, 0],
      containerJustify: l = "end",
      extraStyles: m = "",
    }) {
      return `
      <style>
         .wenexus-package-protection {
            display: flex;
            justify-content: ${l};
            align-items: center;
            margin: ${s == null ? void 0 : s.join("px ")};
            gap: ${i[0]} ${i[1]}px;
         }
         
         .wenexus-package-protection__content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: ${t[0]} ${t[1]}px;
         }
         
         .wenexus-package-protection__image {
            max-width: ${e}px;
         }
         
         .wenexus-package-protection__image img {
            width: 100%;
         }
         
         .wenexus-package-protection__desc h5 {
            font-size: ${f}rem;
            margin: 0;
         }
         
         .wenexus-package-protection__desc p {
            font-size: ${a}rem;
            font-weight: ${r};
            margin: ${c == null ? void 0 : c.join("px ")}px;
         }
         
         .wenexus-package-protection__desc a {
            text-decoration: none;
            font-size: 1.5rem;
            outline: 0;
            color: #222;
            transition: .3s;
            ${w ? "display: none;" : ""}
         }
         
         .wenexus-package-protection__toggle {
            accent-color: ${n} !important;
            zoom: 1.55;
         }
         
         ${m}
      </style>`;
    }
    getInsertionPointSelectors() {
      return [
        {
          selector: 'button[type="submit"][name="checkout"]',
          insertPosition: "before",
        },
      ];
    }
    refreshUI(n) {
      location.reload();
    }
    async refreshPriceUI() {
      this.container &&
        (this.container.querySelector(".protection-price").textContent =
          await this.getPrice());
    }
  }
  class p extends o {
    constructor() {
      super(...arguments);
      u(
        this,
        "thumbnail",
        "https://cdn.shopify.com/s/files/1/0010/3134/0085/files/pp-caliconnected.png?v=1716625753",
      );
    }
    static shouldUse() {
      var e;
      return (
        ((e = window.theme) == null ? void 0 : e.info.name) === "Enterprise"
      );
    }
    getBoundaryParent(e) {
      if (e.boundaryParents) return e;
      const i = document.querySelectorAll(e.selector),
        t = new Set();
      for (const r of i) {
        let a = r.parentElement;
        for (; !(!a || a.tagName === "CART-DRAWER");) a = a.parentElement;
        t.add(a ?? document.body);
      }
      return (t.size === 0 && t.add(document.body), (e.boundaryParents = t), e);
    }
    getInsertionPointSelectors() {
      return [
        { selector: 'button[name="checkout"]', insertPosition: "before" },
      ].map((i) => this.getBoundaryParent(i));
    }
    async getStyleMarkup(e) {
      return super.getStyleMarkup({
        imageWidth: 66,
        containerMargin: [10, 0, 12, 0],
        containerJustify: "space-between",
        titleFontSize: 1.8,
        descriptionFontSize: 1.1,
        hideDescriptionPage: !1,
        descriptionMargin: [2, 0, 0, 0],
        ...e,
        accentColor: "#2c7e3f",
        extraStyles: `
      ${Object.values(this.api.variants)
        .map(
          (i) =>
            `.cart-item[data-variant-id="${i}"] .cart-item__qty, .cart-item[data-variant-id="${i}"] .cart-item__variants`,
        )
        .join(",")} { display: none; }
      `,
      });
    }
    async refreshUI() {
      var e;
      ((e = document.getElementById("cart-items")) == null || e.refresh(),
        await this.refreshPriceUI());
    }
  }
  document.addEventListener("DOMContentLoaded", async () => {
    var f, w;
    const n = [p, o].find((s) => (s.shouldUse ? s.shouldUse() : !0));
    if (!n) return console.error("No package protection client found");
    const e = !0,
      i = () => {
        const s = localStorage.getItem("package-protection-enabled");
        return s === null ? e : s === "true";
      },
      t = new d(
        Number(
          ((f = document.getElementById("package-protection-percentage")) ==
          null
            ? void 0
            : f.innerText) ?? 6,
        ),
        i(),
      ),
      r = new n(t),
      a =
        ((w = r.getInsertionPointSelectors) == null ? void 0 : w.call(r)) || [];
    async function c(s = !1) {
      const l = await t.refresh(),
        m = localStorage.getItem("package-protection-item") || null,
        g = (l == null ? void 0 : l.variant_id.toString()) || null;
      (localStorage.setItem(
        "package-protection-item",
        (l == null ? void 0 : l.variant_id.toString()) ?? "",
      ),
        (s || m !== g) && r.refreshUI(l ?? null));
    }
    (t.setVariants({
      0.25: 43220068630699,
      0.75: 43220068663467,
      "1.50": 43220068696235,
      2.25: 43220068729003,
      "3.00": 43220068761771,
      3.75: 43220068794539,
      "4.50": 43220068827307,
      5.25: 43220068860075,
      "6.00": 43220068892843,
      6.75: 43220068925611,
      "7.50": 43220068958379,
      8.25: 43220068991147,
      "9.00": 43220069023915,
      9.75: 43220069056683,
      "10.50": 43220069089451,
      11.25: 43220069122219,
      "12.00": 43220069154987,
      12.75: 43220069187755,
      "13.50": 43220069220523,
      14.25: 43220069253291,
      "15.00": 43220069286059,
      15.75: 43220069318827,
      "16.50": 43220069351595,
      17.25: 43220069384363,
      "18.00": 43220069417131,
      18.75: 43220069449899,
      "19.50": 43220069482667,
      20.25: 43220069515435,
      "21.00": 43220069548203,
      21.75: 43220069580971,
      "22.50": 43220069613739,
      23.25: 43220069646507,
      "24.00": 43220069679275,
      24.75: 43220069712043,
      "25.50": 43220069744811,
      26.25: 43220069777579,
      "27.00": 43220069810347,
      27.75: 43220069843115,
      "28.50": 43220069875883,
      29.25: 43220069908651,
      "30.00": 43220069941419,
      30.75: 43220069974187,
      "31.50": 43220070006955,
      32.25: 43220070039723,
      "33.00": 43220070072491,
      33.75: 43220070105259,
      "34.50": 43220070138027,
      35.25: 43220070170795,
      "36.00": 43220070203563,
      36.75: 43220070236331,
      "37.50": 43220070269099,
      38.25: 43220070301867,
      "39.00": 43220070334635,
      39.75: 43220070367403,
      "40.50": 43220070400171,
      41.25: 43220070432939,
      "42.00": 43220070465707,
      42.75: 43220070498475,
      "43.50": 43220070531243,
      44.25: 43220070564011,
      "45.00": 43220070596779,
      45.75: 43220070629547,
      "46.50": 43220070662315,
      47.25: 43220070695083,
      "48.00": 43220070727851,
      48.75: 43220070760619,
      "49.50": 43220070793387,
      50.25: 43220070826155,
      "51.00": 43220070858923,
      51.75: 43220070891691,
      "52.50": 43220070924459,
      53.25: 43220070957227,
      "54.00": 43220070989995,
      54.75: 43220071022763,
      "55.50": 43220071055531,
      56.25: 43220071088299,
      "57.00": 43220071121067,
      57.75: 43220071153835,
      "58.50": 43220071186603,
      59.25: 43220071219371,
      "60.00": 43220071252139,
      60.75: 43220071284907,
      "61.50": 43220071317675,
      62.25: 43220071350443,
      "63.00": 43220071383211,
      63.75: 43220071415979,
      "64.50": 43220071448747,
      65.25: 43220071481515,
      "66.00": 43220071514283,
      66.75: 43220071547051,
      "67.50": 43220071579819,
      68.25: 43220071612587,
      "69.00": 43220071645355,
      69.75: 43220071678123,
      "70.50": 43220071710891,
      71.25: 43220071743659,
      "72.00": 43220071776427,
      72.75: 43220071809195,
      "73.50": 43220071841963,
      74.25: 43220071874731,
    }),
      window.weNexusCartApi.addListener(() => c()),
      typeof r.getStyleMarkup == "function" &&
        document.head.insertAdjacentHTML(
          "beforeend",
          await r.getStyleMarkup({ accentColor: "#52c939", imageWidth: 48 }),
        ));
    for (const s of a) {
      if (s.shouldUse && !s.shouldUse()) continue;
      new window.WeNexusQuerySelectorLive(
        s.selector,
        s.boundaryParents,
      ).addListener(async (m) => {
        for (const g of m) {
          const { container: y, checkbox: P } =
            await r.getCheckboxContainer(i());
          switch (s.insertPosition) {
            case "before":
              g.insertAdjacentElement("beforebegin", y);
              break;
            case "after":
              g.insertAdjacentElement("afterend", y);
              break;
            case "inside":
              g.insertAdjacentElement("afterbegin", y);
              break;
            case "replace":
              g.replaceWith(y);
              break;
          }
          P.addEventListener("change", async () => {
            (localStorage.setItem(
              "package-protection-enabled",
              P.checked.toString(),
            ),
              (t.enabled = i()),
              await c(!0));
          });
        }
      });
    }
    await c();
  });
})();